<template>
  <!-- 修改密码组件 -->
  <div class="pwd-chg-container">
    <div v-if="!hasPassWord" class="pwd-chg-goset">
      <span class="pwd-chg-sp">您暂未设置登录密码</span>
      <el-button type="primary" @click.native="goSet()">去设置</el-button>
    </div>
    <div v-else-if="!hashSendSms">
      <SmsSend
        @SendSmsSubmit="SendSmsSubmit"
        @SendSmsCode="SendSmsCode"
      ></SmsSend>
    </div>
    <div v-else-if="!successed">
      <PassWordInput @SetPassWordSubmit="SetPassWordSubmit"></PassWordInput>
    </div>
    <div v-else class="pwd-chg-succ">
      <Successed :post="succPost"></Successed>
    </div>
  </div>
</template>

<script>
import SmsSend from '@/components/PassWord/SmsSend'
import PassWordInput from '@/components/PassWord/PassWordInput'
import Successed from '@/components/Successed'
import {
  SendChangePwdSmsAsync,
  ChangePwdSmsCodeCheck,
  SetPassWordSubmit
} from '@/api/author'
export default {
  components: { SmsSend, PassWordInput, Successed },
  name: 'PassWordChanging',
  props: {
    post: {
      type: Object
    }
  },
  data() {
    return {
      hashSendSms: false,
      successed: false,
      succPost: {
        text: '修改密码成功',
        btnText: '完成',
        btnShow: false
      },
      smsPhoneInfo: {
        phone: '',
        smsCode: ''
      },
      password: '',
      pwSetting: false
    }
  },
  computed: {
    hasPassWord() {
      return this.pwSetting || !this.authorInfo.isPwdNeedSet
    },
    authorInfo() {
      return this.$store.state.user.authorInfo
    },
    userInfo() {
      return this.$store.state.user.userInfo
    }
  },
  created() {},
  methods: {
    goSet() {
      this.pwSetting = true
      this.$emit('goSet')
    },
    showError(msg) {
      if (!msg) {
        msg = '数据请求发生异常，请稍后再试。'
      }

      this.$notify.error({
        position: 'bottom-right',
        title: '错误',
        message: msg
      })
    },
    // 发送修改密码短信
    async SendSmsCode(info) {
      const { result } = await SendChangePwdSmsAsync(info.phone).catch(data => {
        console.log('error:', data)
        this.showError()
      })
      if (result.code === 0) {
        this.$notify({
          position: 'bottom-right',
          title: '成功',
          message: '短信验证码发送成功',
          type: 'success'
        })
      } else if (result.code === 100) {
        this.showError(result.msg)
      } else {
        console.log('error', result)
        this.showError()
      }
    },
    // 校验短信验证码
    async SendSmsSubmit(info) {
      this.smsPhoneInfo = info
      const { result, detail } = await ChangePwdSmsCodeCheck(
        info.phone,
        info.smsCode
      ).catch(data => {
        console.log('error:', data)
        this.showError()
      })
      if (result.code === 0) {
        if (!detail) {
          this.showError('验证码校验失败')
        } else {
          // 验证码校验成功
          this.hashSendSms = true
        }
      } else if (result.code === 100) {
        this.showError(result.msg)
      } else {
        console.log('error', result)
        this.showError()
      }
    },
    // 设置密码
    async SetPassWordSubmit(info) {
      this.password = info.password

      const { result } = await SetPassWordSubmit(
        this.smsPhoneInfo.phone,
        this.smsPhoneInfo.smsCode,
        this.password
      ).catch(data => {
        console.log('error:', data)
        this.showError()
      })
      if (result.code === 0) {
        // 验证码校验成功
        this.successed = true
      } else if (result.code === 22206) {
        this.showError(result.msg)
      } else {
        console.log('error', result)
        this.showError()
      }
    }
  }
}
</script>
<style>
.pwd-chg-container .pwd-chg-goset .el-button--primary {
  font-size: 16px;
  /* height: 34px; */
}
.pwd-chg-container .pwd-chg-goset .el-button{
  padding: 8px 20px;
}
</style>
<style lang="scss" scoped>
.pwd-chg-container {
  margin-top: 40px;
  .pwd-chg-goset {
    .pwd-chg-sp {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 40px;
      letter-spacing: 1px;
      color: #262626;
      margin-right: 30px;
    }
  }
  .pwd-chg-succ {
    display: flex;
    justify-content: center;
    padding-bottom: 20px;
  }
}
</style>
